<div class="keyboard-shortcuts-container">
  <div class="page-title">{{ 'PREF_NAV.KEYBOARD_SHORTCUTS' | translate }}</div>
  <app-clearable-input
    [search]="search"
    (searchChange)="onSearchChange($event)"
    [prefixIcon]="'search'"
    [label]="'KEYBOARD_SHORTCUTS_PREFERENCES.SEARCH_SHORTCUTS' | translate"
    [class]="'full form-no-error density-minus-3'">
  </app-clearable-input>
  @for (section of filteredSections; track section.titleKey) {
    <div class="title-keyboard-shortcuts-setting">{{ section.titleKey | translate }}</div>
    <ul class="shortcut-list">
      @for (shortcut of section.shortcuts; track shortcut.action) {
        <li>
          <span class="shortcut-name">{{ shortcut.labelKey | translate }}</span>
          <span class="shortcut-combo">
            @for (key of getBindingKeys(shortcut.action); track $index) {
              <span class="key-cap">{{ key }}</span>
            }
          </span>
        </li>
      }
    </ul>
  }
</div>
